import SideNavigation from "../components/Navigation/SideNavigation";
import Brand from "../components/Partials/Brand";

const DefaultSidebar = () => {

  const navigationData = [
    {_id:1, label:'Dashboard', link:'/dashboard?tab=revenue', icon:'fa-grid-2' },
    {_id:2, label:'Menu', link:'/menu?tab=list', icon:'fa-fork-knife' },
    {_id:3, label:'Orders', link:'/orders?tab=list', icon:'fa-box' },
    {_id:4, label:'User Manage', link:'/user?tab=admin', icon:'fa-user' },
    {_id:5, label:'Jobs', link:'/jobs?tab=list', icon:'fa-briefcase' },
    {_id:6, label:'CMS', link:'/cms?tab=steps', icon:'fa-file-pen' },
    {_id:7, label:'Blogs', link:'/blogs?tab=list', icon:'fa-pencil' },
    {_id:8, label:'FAQs', link:'/faqs?tab=list', icon:'fa-circle-question' },
    {_id:9, label:'Points', link:'/points', icon:'fa-coins' },
    {_id:10, label:'Organizations', link:'/organizations', icon:'fa-landmark' },
  ]
  return (
    <>
      <div className="sidepanel">
        <div className="site-identity">
          <Brand image={'logo.svg'} alt={'Dabbawala'}/>
        </div>
        <div className="side-navigation scrollbar scrollbar-alt">
          <SideNavigation data={navigationData}/>
        </div>
      </div>
    </>
  );
};

export default DefaultSidebar;
